import { DayProps } from "../Day";
import {
    DaySelectorInputWrapper,
    DaySelectorWrapper,
    StyledInput,
    StyledLabel,
} from "./StyledElements";
import { useDispatch, useSelector } from "../../../../store/store";
import { addDay, isDayDisabled, removeDay } from "../../../../store/data";
import { useTranslation } from "react-i18next";

interface Props {
    day: DayProps;
}

const DaySelector = ({ day }: Props) => {
    const dispatch = useDispatch();
    const dayDisabled = useSelector(isDayDisabled(day));
    const { t } = useTranslation();

    const handleClick = () => {
        dispatch(dayDisabled ? addDay(day) : removeDay(day));
    };

    return (
        <DaySelectorWrapper>
            <DaySelectorInputWrapper>
                <StyledInput
                    onChange={() => null}
                    checked={!dayDisabled}
                    type="checkbox"
                    id={t(day.name) + day.weekType}
                />
                <StyledLabel
                    isRegular={day.isRegular}
                    onClick={handleClick}
                    htmlFor={t(day.name) + day.weekType}
                >
                    {t(day.name)}
                    {day.dateString && <div>{day.dateString}</div>}
                </StyledLabel>
            </DaySelectorInputWrapper>
        </DaySelectorWrapper>
    );
};

export default DaySelector;
